import { createFileRoute, stripSearchParams, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { AutoOrderingPage } from '@/components/Operations/AutoOrderingPage'
import {
  type AutoOrderingSearch,
  autoOrderingSearchSchema,
  EMPTY_AUTO_ORDERING_SEARCH,
  withoutAutoOrderingDefaults,
} from '@/components/Operations/autoOrderingSearch'

/** Wiring only. The schema lives beside the page in `autoOrderingSearch.ts`. */
export const Route = createFileRoute('/_app/operations/auto-ordering')({
  validateSearch: autoOrderingSearchSchema,
  search: { middlewares: [stripSearchParams(EMPTY_AUTO_ORDERING_SEARCH)] },
  component: AutoOrderingRoute,
})

function AutoOrderingRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const onSearchChange = useCallback(
    (next: Partial<AutoOrderingSearch>, options?: { push?: boolean }) =>
      void navigate({
        search: (current) => withoutAutoOrderingDefaults({ ...current, ...next }),
        replace: !options?.push,
        resetScroll: false,
      }),
    [navigate],
  )
  return <AutoOrderingPage search={search} onSearchChange={onSearchChange} />
}
